export function customSelect() {
    if ($("select").length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            maxVisibleItems: 8
        });

        jcf.replaceAll();
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js